import React from 'react'
import { Xmark, Download, Trash } from 'iconoir-react'

const FullScreenViewer = ({ url, onClose, onDelete, onDownload }) => {
    // Détermine si le document est un PDF
    const isPdf =
        url.toLowerCase().endsWith('.pdf') || url.includes('application/pdf')

    return (
        <div className="fixed inset-0 z-50 flex flex-col bg-black bg-opacity-90">
            {/* Barre supérieure avec boutons */}
            <div className="flex items-center justify-end gap-2 bg-gray-800 p-2">
                {onDownload && (
                    <button
                        onClick={onDownload}
                        className="rounded-full p-2 text-white hover:bg-gray-700"
                        title="Télécharger"
                    >
                        <Download className="h-6 w-6" />
                    </button>
                )}

                {onDelete && (
                    <button
                        onClick={onDelete}
                        className="rounded-full p-2 text-red-500 hover:bg-gray-700"
                        title="Supprimer"
                    >
                        <Trash className="h-6 w-6" />
                    </button>
                )}

                <button
                    onClick={onClose}
                    className="rounded-full p-2 text-white hover:bg-gray-700"
                    title="Fermer"
                >
                    <Xmark className="h-6 w-6" />
                </button>
            </div>

            {/* Contenu du document */}
            <div className="flex flex-1 items-center justify-center overflow-auto p-4">
                {isPdf ? (
                    <object
                        data={url}
                        type="application/pdf"
                        className="h-full w-full"
                    >
                        <div className="flex flex-col items-center justify-center rounded-lg bg-white p-8">
                            <p className="mb-4 text-center text-gray-800">
                                Votre navigateur ne peut pas afficher ce PDF.
                            </p>
                            <a
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="rounded-md bg-blue-600 px-4 py-2 text-white transition-colors hover:bg-blue-700"
                            >
                                Ouvrir le PDF dans un nouvel onglet
                            </a>
                        </div>
                    </object>
                ) : (
                    <img
                        src={url}
                        alt="Document en plein écran"
                        className="max-h-full max-w-full object-contain"
                    />
                )}
            </div>
        </div>
    )
}

export default FullScreenViewer
